export default __webpack_public_path__ + "static/media/DSC05917.fe53901d.jpg";